export default __webpack_public_path__ + "static/media/p1.2ae135e5.jpeg";